import React from 'react';
import { Link } from 'react-router-dom';
import { IITH, SANS } from './iithBrand';

export default function LandingFooter({ name, logo, primary }) {
  const accent = primary || IITH.saffron;
  return (
    <footer className="border-t border-white/10 py-12" style={{ background: IITH.ink }}>
      <div className="max-w-6xl mx-auto px-5 sm:px-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-start gap-3">
          {logo ? (
            <img src={logo} alt={name} className="h-12 w-12 object-contain bg-white rounded-full p-1" />
          ) : null}
          <div>
            <p className="text-sm font-semibold text-white" style={{ fontFamily: SANS }}>
              {name || IITH.hospital}
            </p>
            <p className="text-[12px] mt-1" style={{ color: IITH.mute }}>
              {IITH.institute}
            </p>
            <p className="text-[11px] mt-1" style={{ color: IITH.mute }}>
              {IITH.campus}
            </p>
            <p className="text-[11px] mt-3" style={{ color: IITH.mute }}>
              © {new Date().getFullYear()} {name || IITH.hospital}. All rights reserved.
            </p>
          </div>
        </div>
        <div className="flex flex-col items-start md:items-end gap-2 text-[12px]" style={{ color: IITH.mute }}>
          <a
            href="https://hospital.iith.ac.in/"
            target="_blank"
            rel="noreferrer"
            className="hover:text-white"
            style={{ color: accent }}
          >
            hospital.iith.ac.in
          </a>
          <Link to="/login" className="hover:text-white">Staff portal</Link>
        </div>
      </div>
    </footer>
  );
}
